import { isNull, map, pick } from 'lodash-es'

import { APP_NAME, EMPTY_VALUE } from '../../../../common/constants'

import { BUSINESS_STATUSES } from '../../../../brands/constants'
import { TASK_AWAITING_REASONS, TASK_REOPEN_REASONS } from '../../../constants'
import { sortLocationsForBrandDefinitionTask } from '../../../helpers'

const getBrandValues = values => {
  const brand = pick(
    values,
    'id',
    'name',
    'website',
    'isHasNoWebsiteConfirmed',
    'useBrandNameAsLocationName',
    'modifiedDate',
  )

  return {
    ...brand,
    businessStatus:
      BUSINESS_STATUSES[values.businessStatus]?.name || EMPTY_VALUE,
  }
}

const getLocationInitialValues = (values, index) => {
  const location = pick(
    values,
    'id',
    'name',
    'status',
    'businessStatus',
    'phone',
    'exclusionReason',
    'website',
    'coordinates',
    'googlePlaceId',
    'googleMapsUri',
  )

  return {
    ...location,
    position: index + 1,
  }
}

const getTaskValues = values => {
  const task = pick(
    values,
    'id',
    'isAwaiting',
    'status',
    'modifiedDate',
    'reopenedBy',
    'reopenedDate',
    'reopenReason',
    'miscTaskVerifiedBy',
    'miscTaskVerifiedDate',
    'miscTaskVerifiedComment',
    'miscTaskQCVerifiedBy',
    'miscTaskQCVerifiedDate',
    'miscTaskQCVerifiedComment',
    'currentViewType',
    'views',
    'isAssignable',
  )

  return {
    ...task,
    isAssigned: !isNull(values.assignedTo),
    assignedTo: {
      id: values.assignedTo?.id || '',
      name: values.assignedTo?.name || '',
    },
    awaitingReason: values.awaitingReason
      ? TASK_AWAITING_REASONS[values.awaitingReason].name
      : '',
    awaitingReasonComment: values.awaitingReasonComment || '',
    reopenedBy: {
      id: values.reopenedBy?.id || '',
      name: values.reopenedBy?.name || APP_NAME,
    },
    reopenReason: values.reopenReason
      ? TASK_REOPEN_REASONS[values.reopenReason].name
      : '',
    isDone: false,
  }
}

const brandDefinitionTaskState = (values, currentView) => {
  const task = getTaskValues(values)
  const brand = getBrandValues(values.brand)
  const { locations } = values.brand

  const locationsSorted = map(
    sortLocationsForBrandDefinitionTask(locations, currentView),
    (location, index) => getLocationInitialValues(location, index),
  )

  const taskState = {
    task,
    brand,
    locations: locationsSorted,
  }

  return taskState
}

export default brandDefinitionTaskState
